import { connect } from 'react-redux'
import { createWopi360Target } from '../../ducks/wopi360-targets-admin'
import { dismissNoMoreWopiCredits } from '../../ducks/questionnaire-admin'
import { getUnits } from '../../ducks/unit-admin'

import Wopi360TargetCreate from '../Wopi360TargetCreate'

export default connect(
  state => ({
    currentLanguage: state.account.get('currentLanguage'),
    currentAccount: state.account.get('currentAccount'),
    currentOrganisation: state.account.get('currentOrganisation'),
    noMoreWopiCredits: state.questionnaireAdmin.get('noMoreWopiCredits'),
    units: state.unitAdmin.get('units')
  }),
  {
    onCreate: createWopi360Target,
    onDismissNoMoreWopiCredits: dismissNoMoreWopiCredits,
    getUnits
  }
)(Wopi360TargetCreate)



// WEBPACK FOOTER //
// ./src/components/smart/Wopi360TargetCreateContainer.js